export function SelectedTemplateNames({ names }: { names: string[] }) {
  return (
    <>
      <span className="tw-text-[16px] tw-font-bold">Selected templates:</span>
      {names.map((name, index) => (
        <span
          key={index}
          className="tw-rounded tw-border tw-border-solid tw-border-gray-light-1 tw-bg-gray-light-3 tw-px-[10px] tw-py-[8px] tw-text-[12px] tw-font-medium"
        >
          {name}
        </span>
      ))}
    </>
  );
}
